angular.module('dnecom')
    .controller('TransactionsController', ["$scope", "wizardModal", "$http", "$timeout", "notifications", "DTOptionsBuilder", function transactionsController($scope, wizardModal, $http, $timeout, notifications, DTOptionsBuilder) {
        $scope.currentStore = TemplateData.value('store');
        $scope.timezoneOffset = TemplateData.value('timezoneOffset');

        $scope.loading = false;
        $scope.detailsLoading = false;
        $scope.filtersVisible = false;
        $scope.filters = {
            phrase: "",
            dateFrom: "",
            dateTo: ""
        };
        $scope.selectedStatus = 'new';
        $scope.order = { column: "t.createdAt", dir: "desc"};
        $scope.page = 1;
        $scope.pageSize = 15;
        $scope.total = 0;
        $scope.filtered = 0;
        $scope.sortableColumns = {};

        $scope.init = function () {
            $scope.load();
        };

        $scope.editTransaction = function (transaction) {
            var transactionModal = wizardModal.open({
                'templateUrl': 'transactionModal.html',
                'controller': 'TransactionModalController',
                'resolve': {
                    'transaction': function () {
                        return angular.copy(transaction);
                    }
                }
            });

            transactionModal.result.then(function (result) {
                $scope.load();
            });
        };

        $scope.openExportModal = function () {
            var exportModal = wizardModal.open({
                'templateUrl': 'transactionExportModal.html',
                'controller': 'TransactionExportModalController',
                'size': 'md',
                'resolve': {
                    'storeId': function () {
                        return $scope.currentStore.id;
                    }
                }
            });
        };

        $scope.clear = function () {
            var shouldReload = $scope.filters.dateFrom != "" || $scope.filters.dateTo != "";

            $scope.filters.dateFrom = "";
            $scope.filters.dateTo = "";

            if (shouldReload) {
                $scope.setPage(1);
                $scope.load()
            }
        };

        $scope.changeStatus = function (status) {
            $scope.selectedStatus = status;
            $scope.setPage(1);
        };

        $scope.countNewTransactions = function (status) {
            if (!$scope.newTransactionCounts) {
                $scope.newTransactionCounts = [];
            }

            if (!$scope.newTransactionCounts[status]) {
                $scope.newTransactionCounts[status] = _.filter($scope.transactions, function (transaction) {
                    return transaction.isFresh && (!status || transaction.status == status);
                }).length;
            }

            return $scope.newTransactionCounts[status];
        };

        $scope.setOrder = function (columnName) {
            if ($scope.order.column == columnName) {
                if ($scope.order.dir == 'desc') {
                    $scope.order.dir = 'asc';
                } else {
                    $scope.order.dir = 'desc';
                }
            } else {
                $scope.order = { column: columnName, dir: "desc"};
            }
            $scope.setPage(1);
        };

        $scope.setPage = function (page) {
            $scope.page = page;
        };

        $scope.load = function () {
            $scope.loading = true;

            $http.post(
                    Routing.generate('transactions_get', { id: $scope.currentStore.id }),
                    {
                        criteria : $scope.filters,
                        status: $scope.selectedStatus,
                        order: $scope.order,
                        start: $scope.page,
                        length: $scope.pageSize
                    }
                )
                .success(function(response) {
                    if (!response.hasOwnProperty('data') || !response.data.hasOwnProperty('transactions')) {
                        if (response && response.data !== undefined && response.data.message !== undefined) {
                            notifications.danger(response.data.message);
                        } else {
                            notifications.danger('Server error, please refresh the page');
                        }

                        return;
                    }

                    $scope.transactions = response.data.transactions;
                    $scope.total = response.data.total;
                    $scope.filtered = response.data.filtered;
                })
                .finally(function() {
                    $timeout(function() {
                        $scope.loading = false;
                    });
                })
            ;
        };
    }]);
